import React from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { PostApiMethod } from "../../core/services/apiService";
import { DisplayErrorMessages, DisplayToaster, restrictIntialSpace } from "../../core/services/sharedService";
import constant from "../../core/constant";

type Props = {
    showPopups: boolean | undefined,
    handleReset: any
}

export const RequestLocation = ({ showPopups, handleReset }: Props) => {

    const { register, handleSubmit, formState: { errors }, setError, resetField } = useForm<any>();

    const handleRegistration = (data: any, e: any) => {
        e.preventDefault();
        PostApiMethod('tenant/location-crud/create/request', data)
            .then((res: any) => {
                if (res.data.status === "success") {
                    DisplayToaster("bg-success", "Your request has been submitted successfully");
                    handleReset();
                }
            }).catch((err: any) => {
                DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
            })
    }

    return (
        <>
            <Modal show={true} size="lg">
                <Modal.Header>
                    <Modal.Title>Request For Location</Modal.Title>
                </Modal.Header>
                <form onSubmit={(e) => { handleSubmit(handleRegistration)(e) }}>
                    <Modal.Body>
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Location Name <span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-md-4'>
                                <input type="text"
                                    onKeyDown={(e) => restrictIntialSpace(e)}
                                    {...register('location_name', { required: true, minLength: 4, maxLength: 40 })}
                                    maxLength={40} placeholder="My Storage Location" className="form-control" />
                                {errors.location_name?.type === "required" && <small className='text-danger' >Location Name is required</small>}
                                {errors.location_name?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                                {errors.location_name?.type === "maxLength" && <small className='text-danger' >Maximum 40 characters only allowed</small>}
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Address <span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-md-4'>
                                <input type="text"
                                    onKeyDown={(e) => restrictIntialSpace(e)}
                                    {...register('address', { required: true, minLength: 4, maxLength: 100 })}
                                    maxLength={100} placeholder="123 Main street" className="form-control" />
                                {errors.address?.type === "required" && <small className='text-danger' >Address is required</small>}
                                {errors.address?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                                {errors.address?.type === "maxLength" && <small className='text-danger' >Maximum 100 characters only allowed</small>}
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>City <span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-md-4'>
                                <input type="text"
                                    onKeyDown={(e) => restrictIntialSpace(e)}
                                    {...register('city', { required: true, minLength: 2, maxLength: 40 })}
                                    maxLength={40} placeholder="Longview" className="form-control" />
                                {errors.city?.type === "required" && <small className='text-danger' >City is required</small>}
                                {errors.city?.type === "minLength" && <small className='text-danger' >Minimum 2 characters is required</small>}
                                {errors.city?.type === "maxLength" && <small className='text-danger' >Maximum 40 characters only allowed</small>}
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>State <span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-md-4'>
                                <select className="form-select" {...register('state', { required: true })}>
                                    <option value="">Select</option>
                                    {Object.values(constant.StatesArray).map((items: any, i: number) => {
                                        return <option key={i} value={items.name}>{items.name}</option>
                                    })}
                                </select>
                                {errors.state?.type === "required" && <small className='text-danger' >State is required</small>}
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Message</label>
                            </div>
                            <div className='col-md-4'>
                                <textarea onKeyDown={(e) => restrictIntialSpace(e)} {...register('message')} placeholder="Request Location" className="form-control" />
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="reset" className="btn btn-secondary" onClick={handleReset}>
                            Cancel
                        </button>
                        <button className="btn btn-primary" type="submit">
                            Submit
                        </button>
                    </Modal.Footer>
                </form>

            </Modal>
        </>
    )

}
